import React from "react";
import { Chip, Divider } from "@mui/material";
import Div from "@jumbo/shared/Div";
import RenderHTML from "components/RenderHTML";
import SkeletonCard from "components/Skeleton";
import { HEIGHT_OFFSET } from "app/utils/constants/constants";
import { purple } from "@mui/material/colors";

const DescriptionTab = ({ problemData }) => {
  return problemData ? (
    <Div
      sx={{
        p: 2,
        height: `calc(100vh - ${HEIGHT_OFFSET.DEFAULT})`,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <RenderHTML htmlContent={problemData?.defaultTitle} variant="h3" />
      {problemData?.problemTags?.map((tag, id) => (
        <Chip
          key={id}
          label={tag.name}
          sx={{
            marginRight: 1,
            backgroundColor: purple[400],
            color: "white",
          }}
          size="small"
        />
      ))}
      <Divider sx={{ my: 2 }} />
      <RenderHTML
        htmlContent={
          problemData?.problemTranslations?.[0]?.descriptionTranslation
        }
      />
    </Div>
  ) : (
    <SkeletonCard width="80%" count={3} height={50} />
  );
};

export default DescriptionTab;
